import { CalendarItemKind } from '../../constants/calendar'
import { PROFILE_ROUTE_NAMES } from '../../constants/route'
import { getAppointmentMockRecords } from '../Appointment'

function toCalendarMockSavedBuilding(building) {
  return building
    ? {
        ...building,
        short_name: building.name,
        url: PROFILE_ROUTE_NAMES.buildingProfileNG({ id: building.id }),
      }
    : null
}

function toCalendarMockSavedRequest(request) {
  return request
    ? {
        ...request,
        url: PROFILE_ROUTE_NAMES.requestProfileNG({ id: request.id }),
      }
    : null
}

function toCalendarMockSavedAnchor({ building, flat, request }) {
  return {
    building: toCalendarMockSavedBuilding(building),
    flat,
    is_archived: false,
    request: toCalendarMockSavedRequest(request),
    resident: null,
  }
}

function toCalendarMockSavedAppointment(record) {
  return {
    anchor: toCalendarMockSavedAnchor(record.anchor),
    can_edit: record.can_edit,
    end_at: record.end_at,
    id: record.id,
    is_all_day: record.is_all_day,
    kind: CalendarItemKind.appointment,
    participant_count: record.participants.length,
    start_at: record.start_at,
    status: record.status,
    title: record.title,
  }
}

// What the form saved on its own mock, as the feed returns it once both are served (TM-01-10)
export function getCalendarMockSavedAppointments() {
  return getAppointmentMockRecords()
    .filter(record => !record.deletedAt)
    .map(toCalendarMockSavedAppointment)
}
